/* Brainy Bounce · hero promo countdown.
   Two modes, both computed from shared UTC timestamps so every visitor sees the same time and
   nothing restarts on refresh: data-end = one fixed end date (chest hides once it passes);
   data-start + data-hours = repeating cycle that renews every N hours.
   Functional: keeps running even when decorative motion is switched off. */
(function () {
  'use strict';
  if (window.__bbPromoLoaded) return;   // the script tag can be re-inserted by the theme editor
  window.__bbPromoLoaded = true;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function setup(el) {
    if (el.__bbcd) { clearTimeout(el.__bbcd); }
    var end = Date.parse(el.getAttribute('data-end') || '');
    var start = Date.parse(el.getAttribute('data-start') || '');
    var cycle = Math.max(1, parseFloat(el.getAttribute('data-hours')) || 76) * 3600000;
    if (isNaN(end) && isNaN(start)) return;
    var out = { d: el.querySelector('[data-cd="d"]'), h: el.querySelector('[data-cd="h"]'), m: el.querySelector('[data-cd="m"]'), s: el.querySelector('[data-cd="s"]') };
    var sr = el.querySelector('[data-cd-sr]'), lastMin = -1;
    function render() {
      var now = Date.now(), r, t;
      if (!isNaN(end)) {
        r = end - now;
        if (r <= 0) { el.hidden = true; return; }   // offer over: don't show a stale timer
      } else {
        var elapsed = (now - start) % cycle; if (elapsed < 0) elapsed += cycle;   // positive modulo
        r = cycle - elapsed;
      }
      t = Math.floor(r / 1000);
      out.d.textContent = pad(Math.floor(t / 86400)); out.h.textContent = pad(Math.floor(t % 86400 / 3600));
      out.m.textContent = pad(Math.floor(t % 3600 / 60)); out.s.textContent = pad(t % 60);
      var mins = Math.floor(t / 60);
      if (mins !== lastMin) { lastMin = mins; sr.textContent = 'About ' + Math.floor(t / 3600) + ' hours and ' + (mins % 60) + ' minutes left in this round.'; }   // not a live region: never read out every second
      // schedule the next tick on the next whole second (no drift, one timer per element)
      el.__bbcd = setTimeout(render, 1000 - (now % 1000) + 5);
    }
    render();
    el.__bbcdRender = render;
  }
  // The row normally sits in the open space above the headline. If that space is too short
  // (small laptop screens), let it flow above the headline instead of overlapping the hero top.
  function fit() {
    document.querySelectorAll('[data-bb-promo]').forEach(function (row) {
      var hero = row.closest('.bb-hero'); if (!hero) return;
      row.classList.remove('is-flow');
      if (getComputedStyle(row).position !== 'absolute') return;
      if (row.getBoundingClientRect().top < hero.getBoundingClientRect().top + 14) row.classList.add('is-flow');
    });
  }
  var fitT = 0; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fit, 120); });
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  function init(scope) { (scope || document).querySelectorAll('[data-bb-countdown]').forEach(setup); fit(); }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    document.querySelectorAll('[data-bb-countdown]').forEach(function (el) { clearTimeout(el.__bbcd); if (el.__bbcdRender) el.__bbcdRender(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { e.target.querySelectorAll('[data-bb-countdown]').forEach(function (el) { clearTimeout(el.__bbcd); }); });
  if (/[?&]bbtest/.test(location.search)) window.__bbCd = { init: init };
})();
